import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept-type";

export const getAllConceptType = () => axios.get(API_PATH + "/get-all");

export const pagingConceptType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getConceptTypeById = (conceptTypeId) => axios.get(API_PATH + "/" + conceptTypeId);

export const saveConceptType = conceptType => axios.post(API_PATH, conceptType);

export const updateConceptType = conceptType => axios.put(API_PATH + "/" + conceptType?.id, conceptType);

export const deleteConceptType = conceptTypeId => axios.delete(API_PATH + '/' + conceptTypeId);
